function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import propTypes from "prop-types";
import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { requests } from "../../modules/user";
import connectRequest from "../../utils/connect-request";
import { withContext } from "../wr-context";
import { Row, SpacedCol } from "../grid";
import { FormikInput } from "../input";
import { FormikButton } from "../button";
import Card from "../card";
import { ErrorText, CenteredText } from "../text";
import { isTokenProvisional } from "../../utils/token";
import Checkbox from "../checkbox-group/checkbox/checkbox";
import Label from "../label";
var validationSchema = object({
    email: string().email().required(),
    password: string().min(5).max(128).required()
});
var LoginForm = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(LoginForm, PureComponent);
    var _super = _createSuper(LoginForm);
    function LoginForm() {
        _classCallCheck(this, LoginForm);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleSubmit = function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (isTokenProvisional(_this.props.context.state.authorization)) {
                _this.props.loginTotp({
                    rememberMe: values.rememberMe,
                    mfaCode: values.mfaCode,
                    provisionalToken: _this.props.context.state.authorization
                }, function(err, data) {
                    setSubmitting(false);
                    if (err) return;
                    console.log(data);
                });
            } else {
                _this.props.login({
                    email: values.email,
                    password: values.password
                }, function(err, data) {
                    setSubmitting(false);
                    if (err) {
                        return;
                    }
                    var context = _this.props.context;
                    context.history.replace(context.getRoutePath("index"));
                });
            }
        };
        return _this;
    }
    var _proto = LoginForm.prototype;
    _proto.renderCredentials = function renderCredentials() {
        var ref;
        var _props = this.props, _loginResponse = _props.loginResponse, loginResponse = _loginResponse === void 0 ? {} : _loginResponse;
        console.log(loginResponse);
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikInput, {
            name: "email",
            type: "email",
            label: "Email",
            fullWidth: true
        })), /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikInput, {
            name: "password",
            type: "password",
            label: "Password",
            placeholder: "",
            fullWidth: true
        })), loginResponse.rejected && /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(ErrorText, {
            shake: true
        }, (ref = loginResponse.reason) === null || ref === void 0 ? void 0 : ref.message))), /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikButton, {
            primary: true,
            type: "submit"
        }, "Log In")));
    };
    _proto.renderMfaSection = function renderMfaSection() {
        var ref;
        var _props = this.props, _loginTotpResponse = _props.loginTotpResponse, loginTotpResponse = _loginTotpResponse === void 0 ? {} : _loginTotpResponse;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 30
            }
        }, /*#__PURE__*/ React.createElement(FormikInput, {
            name: "mfaCode",
            type: "text",
            label: "Enter a 6-digit MFA code",
            fullWidth: true
        }), /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                alignItems: "center"
            }
        }, /*#__PURE__*/ React.createElement(Field, {
            name: "rememberMe"
        }, function(param) {
            var field = param.field, form = param.form;
            return /*#__PURE__*/ React.createElement(Checkbox, {
                checked: !!field.value,
                name: "rememberMe",
                onChange: function(e) {
                    form.setFieldValue("rememberMe", e.target.checked);
                }
            });
        }), /*#__PURE__*/ React.createElement(Label, null, "Remember this device?")))), loginTotpResponse.rejected && /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(ErrorText, {
            shake: true
        }, (ref = loginTotpResponse.reason) === null || ref === void 0 ? void 0 : ref.message))), /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikButton, {
            primary: true,
            type: "submit"
        }, "Submit")));
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ React.createElement(Formik, {
            onSubmit: this.handleSubmit,
            initialValues: this.props.initialValues,
            validationSchema: this.props.validationSchema
        }, /*#__PURE__*/ React.createElement(Form, {
            noValidate: true
        }, /*#__PURE__*/ React.createElement(Card, {
            md: true
        }, function(param) {
            var Body = param.Body;
            return /*#__PURE__*/ React.createElement(Body, null, /*#__PURE__*/ React.createElement(Row, null, isTokenProvisional(_this.props.context.state.authorization) ? _this.renderMfaSection() : _this.renderCredentials()));
        })));
    };
    return LoginForm;
}(PureComponent);
LoginForm.propTypes = {
    initialValues: propTypes.object,
    validationSchema: propTypes.object
};
LoginForm.defaultProps = {
    initialValues: {
        email: "",
        password: "",
        mfaCode: "",
        rememberMe: false
    },
    validationSchema: validationSchema
};
export default connectRequest(function() {
    return {
        login: requests.login,
        loginTotp: requests.loginTotp
    };
})(withContext(LoginForm));
